import styled, { css } from 'styled-components';
import { svgToCssUrl } from 'src/utils/svgToCssUrl';
import { SvgHelperWrapper } from '../Icon/iconHelper';
import TickSvg from './checkmark.svg';
import TickDarkSvg from './checkmark-dark.svg';

export const Checkbox = styled.input<{ $hasOverlay?: boolean; $withCheckmark?: boolean }>(
  ({ theme, $hasOverlay, $withCheckmark }) => css`
    appearance: none;
    /* hide default styles */
    background: ${$hasOverlay ? theme.co.secondary20 : 'none'};
    border: none;
    margin: 0;
    position: absolute;
    cursor: pointer;
    height: ${$withCheckmark ? theme.sz.s6 : theme.sz.s4};
    width: ${$withCheckmark ? theme.sz.s6 : theme.sz.s4};

    &:checked {
      background: ${$hasOverlay ? theme.co.primary20 : 'none'};
    }
  `,
);

export const CheckboxContainer = styled.div<{ $checked: boolean }>(
  ({ theme, $checked }) => css`
    background-color: ${theme.co.neutral99};
    border: ${theme.sz.s05} solid ${theme.co.neutral20};
    border-radius: ${theme.bo.extraSmall};
    box-sizing: content-box;
    display: inline-block;
    position: relative;
    z-index: 1;
    height: ${theme.sz.s4};
    width: ${theme.sz.s4};

    &::after {
      position: absolute;
      content: '';
      pointer-events: none;
      border-radius: 0.1rem;
      z-index: 3;
      height: ${theme.sz.s3};
      width: ${theme.sz.s3};
      bottom: ${theme.sz.s05};
      left: ${theme.sz.s05};
      background-color: ${$checked ? theme.co.primary20 : theme.co.neutral99};
      transform: scale(${$checked ? 1 : 0.1});
      transition:
        background-color 0.2s ease,
        transform 0.2s ease;
    }
  `,
);

export const CheckboxContainerWithCheckmark = styled.div<{
  $checked?: boolean;
  $disabled?: boolean;
  $hasOverlay?: boolean;
}>(
  ({ theme, $checked, $disabled, $hasOverlay }) => css`
    background-color: ${$hasOverlay ? theme.co.secondary20 : theme.co.neutral99};
    border: ${theme.sz.s05} solid ${$hasOverlay ? theme.co.primary20 : theme.co.neutral20};
    border-radius: ${theme.bo.extraSmall};
    box-sizing: content-box;
    display: inline-block;
    position: relative;
    z-index: 1;
    width: ${theme.sz.s6};
    height: ${theme.sz.s6};

    ${
      $checked &&
      css`
        background-color: ${theme.co.secondary0};
      `
    }

    ${
      $disabled &&
      css`
        background-color: transparent;
        border: ${theme.sz.s05} solid ${theme.co.secondary90};
      `
    }

    svg {
      color: white;
    }

    &::after {
      position: absolute;
      content: '';
      pointer-events: none;
      border-radius: 0.1rem;
      z-index: 3;
      height: ${theme.sz.s5};
      width: ${theme.sz.s5};
      top: ${theme.sz.s05};
      left: ${theme.sz.s05};
      background-color: ${$hasOverlay ? theme.co.secondary20 : theme.co.neutral99};

      ${
        $checked &&
        css`
          background-image: ${svgToCssUrl(
            <SvgHelperWrapper Svg={$hasOverlay ? TickDarkSvg : TickSvg} />,
          )};
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center center;
          background-color: ${$hasOverlay ? theme.co.primary20 : theme.co.secondary0};
        `
      }
    }
  `,
);

export const CheckboxOverlay = styled.div(
  ({ theme }) => css`
    position: absolute;
    top: ${theme.sz.s2};
    left: ${theme.sz.s2};
    z-index: 10;
    background: ${theme.co.secondary20};
    border-radius: ${theme.bo.small};
    padding: ${theme.sz.s1};
    display: flex;
    align-items: center;
    justify-content: center;
  `,
);
